import { IAddressForm, IFieldsData, IShipwallet, ISteps, RootState } from '@checkout/state';
import * as cx from 'classnames';
import { Field, FormikContext, connect as formikConnect } from 'formik';
import { debounce } from 'lodash';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { IngridWidget2 } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import messages from '../../../i18n/base-en';
import { changeStepRequest, checkIngridDeliveryOptionRequest, saveFormValues } from '../../../reducers/checkout';
import { Button } from '../../presentational';
import { InputField } from '../../presentational';
import { minLength, required } from './../../../utils/validators';
import * as Styles from './IngridFieldsForm.scss';

// const moment = require('moment');

interface IFormProps {
  readOnly?: boolean;
  isValid?: boolean; // This is injected from CheckoutForm
}

interface IConnectedProps {
  shippingAddress: IAddressForm;
  steps: ISteps;
  shipwallet: IShipwallet;
  isFetching: boolean;
}

interface IConnectedFormikProps {
  formik: FormikContext<Partial<IFieldsData>>;
}

interface IConnectetDispatchProps {
  saveFormValues: typeof saveFormValues;
  changeStepRequest: typeof changeStepRequest;
  checkIngridDeliveryOptionRequest: typeof checkIngridDeliveryOptionRequest;
}

interface IOwnState {
  blocked: boolean;
  hidden: boolean;
}

type Props = IFormProps & IConnectedProps & IConnectedFormikProps & IConnectetDispatchProps & InjectedIntlProps;

class IngridFieldsForm extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    blocked: false,
    hidden: true,
  };

  /* showOpenBoxInfo = (): boolean => {
    const format = 'HH:mm:ss';
    const time = moment(moment(), format);
    const beforeTime = moment('11:00:00', format);
    const afterTime = moment('21:00:00', format);

    return !time.isBetween(beforeTime, afterTime);
  } */

  componentWillMount() {
    setTimeout(() => {
      this.show();
    }, 400); // This is because shipwallet widget can not re-render that quick
  }

  componentDidMount() {
    // TODO: Initial default city is hardcoded now, think how we can set default value initially
    // Timeout function used because of formik problem: https://github.com/jaredpalmer/formik/issues/930
    setTimeout(() => {
      this.props.formik.setFieldValue('shippingAddress.city', 'Stockholm');
    }, 600);
  }

  /* componentWillReceiveProps(nextProps: Props) {
    if (nextProps.shipwallet.error !== this.props.shipwallet.error && nextProps.shipwallet.error) {
      this.clearValues();
    }
  }

  clearValues = () => {
    this.props.formik.setFieldValue('shippingAddress.address1', '');
    this.props.formik.setFieldValue('shippingAddress.zipCode', '');
  } */

  show = () => {
    this.setState({ hidden : false });
  }

  handleFieldChange = debounce(() => {
    const { checkIngridDeliveryOptionRequest: checkIngridOptions, formik } = this.props;
    const address1 = formik.values.shippingAddress && formik.values.shippingAddress.address1;
    const country = formik.values.shippingAddress && formik.values.shippingAddress.country;
    const city = formik.values.shippingAddress && formik.values.shippingAddress.city;
    const zipCode = formik.values.shippingAddress && formik.values.shippingAddress.zipCode.replace(/\s/g, '');

    const isValid = this.validateAddressField(address1 ? address1 : '') === undefined &&
    this.validateZipField(zipCode ? zipCode : '') === undefined;

    this.setState({ blocked: false });

    if (isValid) {
      checkIngridOptions({ shippingAddress: { country, city, address1, zipCode } });
    }
  }, 800);

  validateAddressField = (value: string) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    let error;
    const minLengthError = minLength(value, 2, formatMessage(messages.min_length_error, { min: 2 }));

    if (minLengthError) {
      error = minLengthError;
    }

    return error;
  }

  validateZipField = (value: string) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    let error;
    const requiredError = required(value, formatMessage(messages.required_valid_error));
    const minLengthError = minLength(value, 5, formatMessage(messages.min_length_error, { min: 5 }));
    const zipError = !/^\d{5}$|^\d{3} \d{2}$/.test(value) ? 'Ogiltigt postnummerformat \n [XXXXX eller XXX XX]' : undefined;

    if (requiredError) {
      error = requiredError;
    } else if (minLengthError) {
      error = minLengthError;
    } else if (zipError) {
      error = zipError;
    }

    return error;
  }

  render() {
    const { readOnly, shipwallet, intl, isFetching } = this.props;
    const { blocked, hidden } = this.state;
    const { formatMessage } = intl;
    const deliveryOptionsAvailable = !(shipwallet.deliveryOptionsAvailable === undefined || shipwallet.deliveryOptionsAvailable || !!shipwallet.error);

    const fieldsClassNames = cx({
      [Styles.fields]: !readOnly,
    });

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            <div className={fieldsClassNames}>
              <Field
                component={InputField}
                type="text"
                name="shippingAddress.address1"
                id="shippingAddress.address1"
                sizeVariant="medium"
                readOnly={readOnly}
                label={formatMessage(messages.address_1_label)}
                placeholder={formatMessage(messages.address_1_placeholder)}
                onChange={this.handleFieldChange}
                validate={this.validateAddressField}
              />
              {/*<Field
                component={DropDownField}
                type="select"
                name="shippingAddress.city"
                id="shippingAddress.city"
                sizeVariant="medium"
                readOnly={readOnly}
                label={formatMessage(messages.city_label)}
                placeholder={formatMessage(messages.city_placeholder)}
                options={checkoutContextConfig.dataDictionary.cities}
                valueSelector={(item: ICityDictionary) => item.city}
                disabled={true}
              /> */}
              <Field
                component={InputField}
                type="text"
                name="shippingAddress.zipCode"
                id="shippingAddress.zipCode"
                sizeVariant="small"
                readOnly={readOnly}
                label={formatMessage(messages.zip_code_label)}
                placeholder={formatMessage(messages.zip_code_placeholderl)}
                onChange={this.handleFieldChange}
                validate={this.validateZipField}
                required={true}
              />
            </div>
            {!hidden && checkoutContextConfig.ui.ingridFieldsInformationText.enabled && checkoutContextConfig.ui.ingridFieldsInformationText.text !== '' && (
              <div className={Styles.openInfo}>{checkoutContextConfig.ui.ingridFieldsInformationText.text}</div>
            )}
            {!hidden && !shipwallet.error && <IngridWidget2 readOnly={readOnly || blocked} />}
            {!readOnly && (
              <div className={Styles.disabledButtonWrapper}>
                <Button
                  align="center"
                  disabled={deliveryOptionsAvailable || !!shipwallet.error || isFetching}
                  type="submit"
                  variant="primary"
                  isLoading={isFetching}
                  label={formatMessage(messages.shipwallet_step_button_title)}
                />
              </div>
            )}
          </Fragment>
      ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IFormProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      isFetching: state.checkout.isFetching,
      steps: state.checkout.steps,
      shipwallet: state.checkout.selection.shipwallet,
      shippingAddress: state.checkout.fieldsData.shippingAddress,
    }),
    {
      saveFormValues,
      changeStepRequest,
      checkIngridDeliveryOptionRequest
    },
  )
)(formikConnect(IngridFieldsForm));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/IngridFieldsForm/IngridFieldsForm.tsx